import React from 'react'

export default function ShippingPolicies() {

    // on hash click
    const handleHashUrlClick = (ev, hash) => {
        ev.preventDefault()
        if (hash) {
            const elem = document.getElementById(hash)

            // scrolling to element
            if (elem) {
                window.scrollTo(0, elem.offsetTop)
            }
        }
    }
    return (
        <div className="page-split-view">
            <div className="inner">
                {/* text */}
                <div className="text-sec">
                    <div className="frac mb-3" id="ppt1">
                        <p className="head st-fw-600 st-fs-15 text-decoration-underline mb-2">General</p>
                        <ul className="ps-3">
                            <li className="st-fs-15">
                                Transactions made on this website will show a charge from 'Hi Life Tobacco Inc.' on your credit card or bank statement.
                            </li>
                        </ul>
                    </div>
                </div>

                {/* text */}
                <div className="text-sec">
                    <div className="frac mb-3" id="ppt1">
                        <p className="head st-fw-600 st-fs-15 text-decoration-underline mb-2">Shipping</p>
                        <ul className="ps-3">
                            <li className="st-fs-15">
                                We offer Free Shipping on orders of $150 or more.
                            </li>
                            <li className="st-fs-15">
                                All orders are packaged and shipped in discreet brown packaging.
                            </li>
                            <li className="st-fs-15">
                                We use FedEx, UPS and USPS to ship the packages.
                            </li>
                        </ul>
                    </div>
                </div>

                {/* text */}
                <div className="text-sec">
                    <div className="frac mb-3" id="ppt1">
                        <p className="head st-fw-600 st-fs-15 text-decoration-underline mb-2">Processing Time</p>
                        <ul className="ps-3">
                            <li className="st-fs-15">
                                All orders are processed and shipped within 24hrs – 48hrs (Monday – Friday).
                            </li>
                            <li className="st-fs-15">
                                Orders received on the weekends and holidays will be processed on the next business day.
                            </li>
                        </ul>
                    </div>
                </div>


            </div>
        </div>
    )
}
